import { Box } from '@mui/material'
import Currency from 'react-currency-format';
import moment from 'moment'

export const ForPayment = ({record,subdir}) => {
    const header = [
        subdir === 'booking' ? 'Booking No.' : 'Order No.', 
        subdir === 'booking' ? 'Date of Booking' : 'Date of Order', 
        'Sales Amount', 
        'Ref No.', 
        'Payment Method', 
        'Fee', 
        'Net Amount'
    ]
    const tblStyles = {flex: 1, whiteSpace: 'noWrap', p: 1, overflow: 'hidden', textOverflow: 'ellipsis'}
    return (
        <Box height="100%" width="100%" display="flex" flexDirection="column" gap="16px" className="overflowY">
            <Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY" >
                <Box display="flex" alignItems="center" bgcolor="#f2f2f2" borderBottom="1px solid #ddd">
                    {header.map((v,k) => (
                        <Box sx={tblStyles} component="b" fontSize={14}  key={k}>
                            {v}
                        </Box>
                    ))}
                </Box>
                <Box height="100%" width="100%" display="flex" flexDirection="column" className="overflowY">
                    {
                        record.data.list.map((v,k) => (
                            <Box display="flex" alignItems="center" bgcolor="#fff" borderBottom="1px solid #ddd" fontSize={14} key={k}>
                                <Box sx={tblStyles}>
                                    {v.series_num}
                                </Box>
                                <Box sx={tblStyles}>
                                    {
                                        subdir === 'booking' ?
                                            moment(v.date_of_booking).format('MM/DD/YYYY')
                                        :
                                            moment(v.date_of_order).format('MM/DD/YYYY')
                                    }
                                </Box>
                                <Box sx={tblStyles}>
                                    <Currency value= {v.amount} displayType={'text'} thousandSeparator={true} prefix={''} />
                                </Box>
                                <Box sx={tblStyles}>
                                    {v.reference_number}
                                </Box>
                                <Box sx={tblStyles}>
                                    {v.payment_channel_id === 15 ? 'UnionBank' : 'Gcash'}
                                </Box>
                                <Box sx={tblStyles}>
                                    <Currency value={v.payment_fee} displayType={'text'} thousandSeparator={true} prefix={''} />
                                </Box>
                                <Box sx={tblStyles}>
                                    <Currency value= {(v.amount - v.payment_fee).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} />
                                </Box>
                            </Box>
                        ))
                    }
                </Box>
            </Box>
            
        </Box>
    )
}
